function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M416.8,0C208.5,0.1,39.6,169,39.6,377.399V555.2c0,9.399,4.4,18.199,11.9,23.899L213.7,702.2v101.5c0,16.6,13.4,30,30,30 h24.1c16.6,0,30-13.4,30-30v-41.2c0-10.5,8.5-19,19-19l0,0c10.5,0,19,8.5,19,19v41.2c0,16.6,13.4,30,30,30h1c16.6,0,30-13.4,30-30 v-41.2c0-10.5,8.5-19,19-19h2c10.5,0,19,8.5,19,19v41.2c0,16.6,13.4,30,30,30h1c16.6,0,30-13.4,30-30v-41.2c0-10.5,8.5-19,19-19 l0,0c10.5,0,19,8.5,19,19v41.2c0,16.6,13.4,30,30,30H590c16.6,0,30-13.4,30-30V702.1l162.2-123.1c7.5-5.7,11.899-14.5,11.899-23.9 V377.3C794,169,625.1,0.1,416.8,0z M259.1,558.1c-57.4,0-104-46.6-104-104c0-57.399,46.6-104,104-104c57.4,0,104,46.601,104,104 C363.1,511.6,316.5,558.1,259.1,558.1z M446.4,634.6h-59.1c-13.7,0-22.4-14.7-15.8-26.7l29.6-53.699c6.8-12.4,24.7-12.4,31.5,0 l29.601,53.699C468.701,619.899,460,634.6,446.4,634.6z M574.5,558.1c-57.4,0-104-46.6-104-104c0-57.399,46.6-104,104-104 c57.399,0,104,46.601,104,104C678.5,511.6,632,558.1,574.5,558.1z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgSkull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "833.7px",
    height: "833.7px",
    viewBox: "0 0 833.7 833.7",
    style: {
      enableBackground: "new 0 0 833.7 833.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/skull.bf096c5c.svg";
export { ForwardRef as ReactComponent };